<template>
    <button :type="type" :class="buttonClass" :disabled="busy||disabled" @click="type ==='button' ? $emit('execute') : null"
>
        <template v-if="busy">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ (labelLoading) ? labelLoading : 'Please wait...' }}
        </template>
        <template v-else>
            {{ label }}
        </template>
    </button>
</template>

<style scoped>
	@media (max-width: 425px) {
		button:only-child {
			display: block;
			width: 100%;
		}
	}
</style>

<script>
	export default {
        props: {
            label: {
                type: String,
                required: false,
                default: 'Submit',
            },
            labelLoading: {
                type: String,
                required: false,
                default: 'Please wait...',
            },
            buttonClass: {
                type: String,
                required: false,
                default: 'btn btn-primary btn-block shadow-sm',
            },
            busy: {
                type: Boolean,
                required: false,
                default: false,
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
            type: {
                type: String,
                required: false,
                default: 'submit',
            },
        }
	};
</script>
